import { imagePlaceholder } from '@tm/client-form/src/misc/imagePlaceholder'
import { useCallback, useMemo } from 'react'
import { useCampaign } from '../../../../hooks/useCampaign'
import { useI18N } from '../../../../hooks/useI18n'
import { ViewProps } from '../types'
import { UsePictureField } from './types'
import { ContactInfoFields } from './useReviewFields'

export function useProfilePictureField(
  { state, dispatch }: Pick<ViewProps, 'state' | 'dispatch'>,
  fields: ContactInfoFields
): UsePictureField {
  const { t } = useI18N()
  const { primaryColor, primaryTextColor } = useCampaign()
  const profilePictureField = useMemo(() => fields.get('imageFilename'), [fields])

  const onProfilePictureChange = useCallback(
    (files: FileList | null) => {
      const [file] = files || []
      dispatch({ type: 'set file', field: { name: 'imageFilename', system: true }, file })
    },
    [dispatch]
  )

  const value = useMemo(
    () =>
      state.getFile({
        name: 'imageFilename',
        system: true,
      }),
    [state]
  )

  const labelKey =
    profilePictureField && 'labelKey' in profilePictureField && profilePictureField.labelKey
      ? profilePictureField.labelKey
      : 'review.imageFilename'
  const label =
    profilePictureField && 'label' in profilePictureField && profilePictureField.label
      ? profilePictureField.label
      : t(labelKey)

  return {
    value,
    onChange: onProfilePictureChange,
    label,
    primaryColor,
    primaryTextColor,
    chooseImageButtonText: t('file.chooseImage'),
    imagePlaceholder,
  }
}
